import ActionTypes from '../constants/ActionTypes';

const fetchContentTypeTemplates = () => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATES_FETCH,
  payload: {},
});

fetchContentTypeTemplates.success = (items, contentTypes = [], pointSystems = []) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATES_FETCH__SUCCESS,
  payload: {
    items,
    contentTypes,
    pointSystems,
  },
});

fetchContentTypeTemplates.failure = (error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATES_FETCH__FAILURE,
  payload: {
    error,
  },
});

const createContentTypeTemplate = (data) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_CREATE,
  payload: {
    data,
  },
});

createContentTypeTemplate.success = (item, contentTypes = []) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_CREATE__SUCCESS,
  payload: {
    item,
    contentTypes,
  },
});

createContentTypeTemplate.failure = (error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_CREATE__FAILURE,
  payload: {
    error,
  },
});

const updateContentTypeTemplate = (id, data) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_UPDATE,
  payload: {
    id,
    data,
  },
});

updateContentTypeTemplate.success = (item, included = {}) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_UPDATE__SUCCESS,
  payload: {
    item,
    pointSystems: included.pointSystems || [],
  },
});

updateContentTypeTemplate.failure = (id, error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteContentTypeTemplate = (id) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_DELETE,
  payload: {
    id,
  },
});

deleteContentTypeTemplate.success = (item, included = {}) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_DELETE__SUCCESS,
  payload: {
    item,
    pointSystems: included.pointSystems || [],
    contentTypeIds: included.contentTypeIds || [],
    contentCardDefaultIds: included.contentCardDefaultIds || [],
    contentViewPlans: included.contentViewPlans || [],
  },
});

deleteContentTypeTemplate.failure = (id, error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

const createContentTypeTemplateItem = (templateId, data) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_CREATE,
  payload: {
    templateId,
    data,
  },
});

createContentTypeTemplateItem.success = (item) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_CREATE__SUCCESS,
  payload: {
    item,
  },
});

createContentTypeTemplateItem.failure = (templateId, error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_CREATE__FAILURE,
  payload: {
    templateId,
    error,
  },
});

const updateContentTypeTemplateItem = (id, data) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_UPDATE,
  payload: {
    id,
    data,
  },
});

updateContentTypeTemplateItem.success = (item) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateContentTypeTemplateItem.failure = (id, error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteContentTypeTemplateItem = (id) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_DELETE,
  payload: {
    id,
  },
});

deleteContentTypeTemplateItem.success = (item) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_DELETE__SUCCESS,
  payload: {
    item,
  },
});

deleteContentTypeTemplateItem.failure = (id, error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

const fetchContentTypes = (pointSystemId) => ({
  type: ActionTypes.CONTENT_TYPES_FETCH,
  payload: {
    pointSystemId,
  },
});

fetchContentTypes.success = (pointSystemId, items) => ({
  type: ActionTypes.CONTENT_TYPES_FETCH__SUCCESS,
  payload: {
    pointSystemId,
    items,
  },
});

fetchContentTypes.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_TYPES_FETCH__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const createContentType = (pointSystemId, data) => ({
  type: ActionTypes.CONTENT_TYPE_CREATE,
  payload: {
    pointSystemId,
    data,
  },
});

createContentType.success = (item, contentTypeTemplateItems = []) => ({
  type: ActionTypes.CONTENT_TYPE_CREATE__SUCCESS,
  payload: {
    item,
    contentTypeTemplateItems,
  },
});

createContentType.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_TYPE_CREATE__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const updateContentType = (id, data) => ({
  type: ActionTypes.CONTENT_TYPE_UPDATE,
  payload: {
    id,
    data,
  },
});

updateContentType.success = (item, contentTypeTemplateItems = []) => ({
  type: ActionTypes.CONTENT_TYPE_UPDATE__SUCCESS,
  payload: {
    item,
    contentTypeTemplateItems,
  },
});

updateContentType.failure = (id, error) => ({
  type: ActionTypes.CONTENT_TYPE_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteContentType = (id) => ({
  type: ActionTypes.CONTENT_TYPE_DELETE,
  payload: {
    id,
  },
});

deleteContentType.success = (item, contentTypeTemplateItems = []) => ({
  type: ActionTypes.CONTENT_TYPE_DELETE__SUCCESS,
  payload: {
    item,
    contentTypeTemplateItems,
  },
});

deleteContentType.failure = (id, error) => ({
  type: ActionTypes.CONTENT_TYPE_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

const applyContentTypeTemplate = (pointSystemId, templateId) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY,
  payload: {
    pointSystemId,
    templateId,
  },
});

applyContentTypeTemplate.success = (
  pointSystemId,
  pointSystem,
  contentTypes,
  contentViewPlans,
  contentCardDefaults,
  cardPointArchivedData = [],
) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS,
  payload: {
    pointSystemId,
    pointSystem,
    contentTypes,
    contentViewPlans,
    contentCardDefaults,
    cardPointArchivedData,
  },
});

applyContentTypeTemplate.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

export default {
  fetchContentTypeTemplates,
  createContentTypeTemplate,
  updateContentTypeTemplate,
  deleteContentTypeTemplate,
  createContentTypeTemplateItem,
  updateContentTypeTemplateItem,
  deleteContentTypeTemplateItem,
  fetchContentTypes,
  createContentType,
  updateContentType,
  deleteContentType,
  applyContentTypeTemplate,
};
